import * as React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { HistoryRouter } from './components/HistoryRouter';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import { SpinnerLoader } from './components/SpinnerLoader';
import App from './App';
import { flags } from 'config/featureFlags/flags';
import { FlagsProvider } from 'config/featureFlags/flagsConfig';

// TODO: Re-enable in https://stay-well.atlassian.net/browse/PAT-94
// import registerServiceWorker from "./registerServiceWorker";

// Create redux-first-history context
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
});

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(routerMiddleware, routerReducer);
const history = createReduxHistory(store);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <Provider store={store}>
        <HistoryRouter history={history} basename={baseUrl}>
            <FlagsProvider flags={flags}>
                <App />
                <SpinnerLoader />
            </FlagsProvider>
        </HistoryRouter>
    </Provider>,
);

// TODO: Re-enable in https://stay-well.atlassian.net/browse/PAT-94
// registerServiceWorker();
